import { useEffect } from 'react';

import { setDeferredPageName } from '../lib/rum';

/**
 * Мета-информация о странице.
 */
export interface UseRumPageProps {
    /**
     * Человеко-понятное название страницы на латинице.
     */
    pageName: string;
}

/**
 * Включает отправку Rum метрик для просматриваемой страницы, дополняя их мета-информацией о странице.
 *
 * Хук предназначен для использования в корневом компоненте на каждой странице сервиса.
 *
 * @kind helper
 * @param props Мета-информация о текущей странице.
 * @returns undefined
 **/
export function useRumPage(props: UseRumPageProps) {
    const { pageName } = props;

    useEffect(() => {
        setDeferredPageName(pageName);
    }, [pageName]);
}
